<template>
  <div class="p-rel" @click="handleClick">
    <div ref="task" class="task-item" :class="showDeleteButton?'left':''">
      <div class="flex mb-3">
        <TaskStatus :color="color" :status="item.progress"/>
        <span class="grey">{{ assignedName }}</span>
      </div>
      <p class="name">{{ item.companyName }}</p>
      <p class="desc">{{ item.description }}</p>
    </div>
    <div v-if="!showConfirm" class="btn-delete" @click="handleConfirm($event)"></div>
    <div v-else class="btn-confirm-delete" @click="handleDelete($event)">确定<br/>删除</div>
  </div>
</template>

<script>
  import TaskStatus from './TaskStatus';
  import Hammer from 'hammerjs';

  export default {
    name: "TaskItem",
    components: {
      TaskStatus
    },
    props: {
      item: {
        type: Object,
        required: true
      }
    },
    computed: {
      assignedName() {
        if (this.item.assignedName) {
          return '受理人:' + this.item.assignedName;
        } else {
          return '未指派';
        }
      },
      color() {
        switch (this.item.progress) {
          case '已创建':
            return 'danger';
          case '正在处理':
            return 'info';
          case '已完成':
            return 'success';
          default:
            return '';
        }
      }
    },
    data() {
      return {
        showDeleteButton: false,
        showConfirm: false,
      }
    },
    methods: {
      handleConfirm(event) {
        event.stopPropagation();
        this.showConfirm = true;
      },
      handleDelete(event) {
        event.stopPropagation();
        this.$emit('delete');
        this.hideDelete();
      },
      handleClick(event) {
        this.$emit('click');
      },
      hideDelete() {
        this.showDeleteButton = false;
        this.showConfirm = false;
      },
      showDelete() {
        this.showDeleteButton = true;
      }
    },

    mounted() {
      //注意，一定要在移动端测试，否则swipe和click会冲突
      let hammertime = new Hammer(this.$refs.task);
      hammertime.on('swipeleft', () => {
        this.$emit('swipeleft', this.item.taskId + '');
      });
      hammertime.on('swiperight', () => {
        this.hideDelete();
      });
    },

  }
</script>

<style scoped>
  .p-rel {
    position: relative;
  }

  .flex {
    display: flex;
    justify-content: space-between;
  }

  .grey {
    color: #999;
  }

  .task-item {
    width: 100%;
    height: 108px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 1px 1px 6px rgba(0, 0, 0, 0.1);
    opacity: 1;
    border-radius: 5px;
    padding: 12px 17px;
    margin-bottom: 13px;
    position: relative;
    z-index: 1;
    transition: all 0.6s;
  }

  .task-item.left {
    transform: translateX(-60px);
  }

  .desc {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    line-height: 26px;
  }


  .btn-delete {
    width: 44px;
    height: 44px;
    border-radius: 50%;
    position: absolute;
    right: 0;
    top: 50%;
    margin-top: -22px;
    z-index: 0;
    background: #FD493A url('../assets/icon-delete.png') 50% 50% no-repeat;
  }

  .btn-confirm-delete {
    width: 44px;
    height: 44px;
    border-radius: 50%;
    position: absolute;
    right: 0;
    top: 50%;
    margin-top: -22px;
    z-index: 0;
    background: #FD493A;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
  }

  .name{
    font-size: 16px;
    font-weight: bold;
  }
</style>